import { BfKey } from '../models/bfKey'

export function getBfKey(BfkeyRepository) {
  return BfkeyRepository.getBfKey().then(response => new BfKey(response));;
}